import React from "react";

import { InputProps, Stack } from "@mui/material";

import TextField from "@app/analytics/components/TextField";

import { SettingSubtitle } from "../../components/styles";
import UpdateButtons from "../../components/UpdateButtons";

interface EmailForm {
  error: boolean;
  helperText?: string | null;
  inputProps: InputProps;
  disabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const EmailForm = ({
  error,
  helperText,
  inputProps,
  disabled,
  onCancel,
  onSubmit,
}: EmailForm) => {
  return (
    <Stack spacing={2}>
      <SettingSubtitle>Update your primary email address</SettingSubtitle>
      <TextField
        label="Email"
        error={error}
        helperText={helperText}
        InputProps={inputProps}
        sx={{ width: "328px", maxWidth: "100%" }}
        fullWidth={false}
      />
      <UpdateButtons
        disabled={disabled}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    </Stack>
  );
};

export default EmailForm;
